'use client';

import { useIsSp } from '@/hooks/useMediaQuery';
import type { UserDesignItem } from '@/types';
import { createSlideItems } from '@/utils/createSlideItems';
import type { Splide } from '@splidejs/react-splide';
import { useMemo, useRef } from 'react';

/**
 * ユーザーデザインスライダー用の共通フック（画面サイズ判定・スライドアイテム生成・Splide操作）
 * @param userDesigns ユーザーデザインの一覧データ
 * @param perPageSp SP表示時に1ページあたりに表示するアイテム数
 * @param perPagePc PC表示時に1ページあたりに表示するアイテム数
 * @returns スライダーの状態および制御用ハンドラをまとめたオブジェクト（isSp, slideItems, splideRef, handleSlidePrev, handleSlideNext）
 */
export const useUserDesignSlider = (userDesigns: UserDesignItem[], perPageSp: number, perPagePc: number) => {
  const isSp = useIsSp();
  const perPage = isSp ? perPageSp : perPagePc;
  const splideRef = useRef<Splide>(null);
  const slideItems = useMemo(() => createSlideItems(userDesigns, perPage), [userDesigns, perPage]);

  const handleSlidePrev = () => {
    if (splideRef.current) {
      splideRef.current.go('<');
    }
  };

  const handleSlideNext = () => {
    if (splideRef.current) {
      splideRef.current.go('>');
    }
  };

  return {
    isSp,
    slideItems,
    splideRef,
    handleSlidePrev,
    handleSlideNext,
  };
};
